fetch("./assets/img/gallery-images.txt").then((response)=>response.text()).then((text)=>{
    let images = text.split("\n");
    let imgViewer = document.getElementById("imgViewer");
    var imgModal = new bootstrap.Modal(document.getElementById("imgModal"));
    for(let i = 0; i < images.length; i++){
        let thumbUrl = images[i].slice(0, images[i].lastIndexOf(".")) + "s" + images[i].slice(images[i].lastIndexOf("."));
        let img = document.createElement("img");
        img.classList.add("img-thumbnail", "m-1");
        img.src = thumbUrl;
        img.alt = images[i];
        img.height = 100;
        img.onclick = function() {
            imgViewer.src = images[i];
            imgViewer.alt = images[i];
            imgModal.show();
        };
        document.getElementById("imgGallery").appendChild(img);
    }
});

//# sourceMappingURL=gallery.69a908c4.js.map
